import React, { useState, useRef, useEffect } from "react";
import TransferReceiverSelectComponent from "./transferReceiverSelect.component";
import { selectLoading } from "modules/notification";
import TransferReceiverSelectPanelComponent from "./transferReceiverSelectPanel.component";
import { getTransferReceiverDropdown } from "modules/stockflow/redux";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep } from "lodash";

function TransferReceiverSelectContainer({
  handleChange,
  disabled,
  value,
  styles,
  textStyles,
  placeholder,
}) {
  const isFetching = useSelector((state) =>
    selectLoading(state, getTransferReceiverDropdown.typePrefix)
  );
  const transferReceiverDropdown = useSelector(
    (state) => state.stockflowTransfer.transferReceiverDropdown
  );
  const lang = useSelector((state) => state.constant.languages);
  const [open, setOpen] = useState(false);
  const [isOpenList] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);
  const prevOpenList = useRef(isOpenList);
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTransferReceiverDropdown({ search }));
  }, [search, dispatch]);

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus();
    }

    prevOpenList.current = isOpenList;
  }, [isOpenList]);

  useEffect(() => {
    setSelectAll(value.length === transferReceiverDropdown.length);
  }, [value, transferReceiverDropdown]);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSearch("");
  };

  const handleSelectAll = async () => {
    if (!selectAll) {
      let selectedReceiver = transferReceiverDropdown.map((p) => {
        return p.uuid;
      });
      handleChange(selectedReceiver);
    } else {
      handleChange([]);
    }
  };

  const handleSelectReceiver = (receiver) => {
    let temp = cloneDeep(value);

    if (temp.findIndex((t) => t === receiver.uuid) >= 0) {
      temp = temp.filter((t) => t !== receiver.uuid);
    } else {
      temp.push(receiver.uuid);
    }
    handleChange(temp);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <>
      <TransferReceiverSelectComponent
        anchorRef={anchorRef}
        disabled={disabled}
        value={value}
        handleClick={handleOpen}
        styles={styles}
        textStyles={textStyles}
        placeholder={placeholder}
        lang={lang}
      />
      <TransferReceiverSelectPanelComponent
        selectAll={selectAll}
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isFetching}
        transferReceiverDropdown={transferReceiverDropdown}
        handleSelectAll={handleSelectAll}
        handleSelectReceiver={handleSelectReceiver}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  );
}

export default TransferReceiverSelectContainer;
